import React, { FC, useState, useEffect, useMemo } from 'react'
import { KeyboardAvoidingView, View, useWindowDimensions, ScrollView, Pressable, BackHandler } from 'react-native'
import { useIsFocused } from '@react-navigation/native'
import { useFormik } from 'formik';
import * as yup from 'yup'
import moment from 'moment'
import Toast from 'react-native-toast-message'
import { AxiosError } from 'axios'
import Popover from 'react-native-popover-view/dist/Popover'
import { getScreenPermission, useAppDispatch, useAppSelector } from '../../../redux/hooks';

// Common Component
import CommonHeader from '../../../shared/commonComponents/commonHeader'
import CommonDialogBox from '../../../shared/commonComponents/commonDialogBox'
import { appColors, fontSize, appFonts } from '../../../themes/appTheme'
import { config } from '../../../shared/environment'
import { propertyValueDataType, restrictionValueType, updatepayloadType, buyxData, propertyValuesType, getyData, productItem, discountValueType, discountRes, selectProductType, categoryData, applicableToType, customerEligibility, roleType, roleData, customerGroup, customer, customerGroupArr, productType, categoryType, updatePayload, productArr } from '../buyXgetYDiscount/addEditBuyXgetYDiscountModule'
import { checkExistBuyXgetYDiscountName, getOneDiscount, getPosPropertyCode, saveBuyXgetY, updateBuyXgetY, getDiscountAppliesTo } from '../../../redux/slices/buyXgetYDiscountSlice';
import { addEditBuyXgetYDiscountStyle } from '../../../themes/components/discounts/addEditBuyXgetYDiscountStyle'
import { useAppNavigation, useAppRoute } from '../../../types/@react-navigation/navigation';
import { ZenLoader, ZenText, ZenButton, ZenDateTimePicker, ZenInput, ZenIcon, ZenSwitch, ZenCheckBox, ZenToolTip, ZenDropdown, ZenToast } from 'zen-core-elements';
import { CustomerGroupDataProps } from '../../customerGroups/customerGroupModule';
import { useTheme } from '@rneui/themed';
import { shallowEqual } from 'react-redux';

const currentDate = new Date()

const AddEditBuyXgetYDiscount: FC = () => {
    const { isWrite } = useAppSelector(getScreenPermission("BuyXgetYDiscountStack"), shallowEqual);

    // Variable which is used to render styles based on device dimention
    const { width } = useWindowDimensions()
    // Variable which is used to store focused state
    const isFocused = useIsFocused()
    // Variable which is used to store navigation 
    const navigation = useAppNavigation()
    // Variable which is used to store route
    const { params } = useAppRoute("AddEditBuyXgetYDiscount")
    // Variable which is used to store loader state
    const [load, setLoad] = useState<boolean>(false)
    // Variable which is used to show/hide date
    const [showDate, setShowDate] = useState<boolean>(false)
    //variable to set hold the current date
    const [mydate, setDate] = useState(new Date());
    //Variable to set startDate
    const [startDateSelected, setStartDateSelected] = useState<boolean>(false);
    // Variable which is used to store customer eligibility type
    const [customerEligibilityType, setCustomerEligibilityType] = useState<customerEligibility[] | any>([]);
    // Variable which is used open/close customerEligibilityType dropdown
    const [eligibilityOpen, setEligibilityOpen] = useState<boolean>(false)
    // Variable which is used to store customer group dropdown values
    const [CustomerGroup, setCustomerGroup] = useState<customerGroupArr[] | any>([])
    // Variable which is used to open/close customer group dropdown
    const [customerGroupOpen, setCustomerGroupOpen] = useState<boolean>(false)
    // Variable which is used to store MultipleCustomerGroup
    const [selectMultipleCustomerGroup, setSelectMultipleCustomerGroup] = useState<string[]>([])
    // Variable which is used to store role drodown values
    const [role, setRole] = useState<customerGroupArr[] | any>([])
    // Variable which is used to open/close role dropdown
    const [roleOpen, setRoleOpen] = useState<boolean>(false)
    // Variable whcih is used to store multipleRole
    const [selectMultipleRole, setSelectMultipleRole] = useState<string[]>([])
    // Variable which is used to store customer dropdown values 
    const [customer, setCustomer] = useState<customerGroupArr[] | any>([])
    // Variable which is used to open/close customer dropdown
    const [openCustomer, setOpenCustomer] = useState<boolean>(false)
    // Variable which is used to store multiple customer
    const [selectMultipleCustomer, setSelectMultipleCustomer] = useState<string[]>([])
    // Variable which is used to store customer buys
    const [customerBuys, setCustomerBuys] = useState<restrictionValueType[]>([])
    // Variable which is used to store customer gets
    const [customerGets, setCustomerGets] = useState<restrictionValueType[]>([])
    // Variable to hold property values
    const property: string[] = ["RECCURRENCE", "APPLICABLE_CUSTOMERS", "APPLICABLE_ITEMS", "APPLICABLE_TO", "DISCOUNT_RESTRICTION_VALUES", "DISCOUNT_CONDITIONAL_TYPE"]
    // Variable which is used to store product dropdown values
    const [product, setProduct] = useState<productType[] | any>([])
    // Variable which is used to category dropdown values
    const [category, setCategory] = useState<categoryType[] | any>([])
    // Variable which is used to store discount values
    const [discountValue, setDiscountValue] = useState<discountRes>()
    // Variable which is used to store choosen product buys id
    const [selectProductBuysId, setSelectProductBuysId] = useState<number>(0)
    // Variable which is used to delete product buys
    const [deleteProductBuys, setDeleteProductBuys] = useState<boolean>(false)
    // Variable which is used to handle button loader
    const [buttonLoader, setButtonLoader] = useState<boolean>(false)
    // Variable which is used to handle discount name is already exists or not
    const [existName, setExistName] = useState<boolean>(false)
    // Variable which is used to store end date expired state
    const [endDateExpired, setEndDateExpired] = useState<boolean>(false)
    //variable is used to open/close the expired warning popover
    const [expiredPopover, setExpiredPopover] = useState<boolean>(false)
    // Variable whcih is used to store isGetyProductUnavailable state
    const [isGetyProductUnavailable, setIsGetyProductUnavailable] = useState<boolean>(false)
    // Variable whcih is used to store isBuyyProductUnavailable state
    const [isBuyyProductUnavailable, setIsBuyyProductUnavailable] = useState<boolean>(false)
    // Variable which is used to leave state
    const [leavePopover, setLeavePopover] = useState<boolean>(false)
    // redux dispatch
    const dispatch = useAppDispatch()
    const { productData, categoryData, roleData, customerGroupData, customerData, propertyCode, getOneDiscount: getOneDiscountState } = useAppSelector(state => state.buyXgetYDiscount)
    const { theme } = useTheme()
    //variable to display the warning message for end date expired
    const expiredDialogProps = {
        content: 'The discount has expired; kindly change the "End date" to further edit the discount.',
        button: [{ id: 1, name: 'Okay', color: appColors.primary, backgroundColor: appColors.light }],
        icon: { name: 'alert-outline', size: 55, color: appColors.warning, type: 'material-community' }
    }

    //variable to display the warning message for product/category does't load
    const WarningProps = {
        content: "Sorry some product / category removed in their corresponding page for buys item/gets item, It's not loaded",
        button: [{ id: 1, name: 'Okay', color: appColors.primary, backgroundColor: appColors.light }],
        icon: { name: 'close-circle-outline', color: appColors.warning, type: 'material-community' }
    }

    // method to perform the validation
    const validationSchema = yup.object().shape({
        discountTitle: yup.string()
            .label('title')
            .max(50, "Discount title should not exceed 50 characters")
            .required('Discount title is required'),
        description: yup.string()
            .max(250, "Description should not exceed 250 characters.")
            .nullable(),
        TotalUsagelimits: yup.number()
            .label('Usage limit')
            .integer("Total usage limits accept only whole numbers.")
            .nullable()
            .typeError('Total usage limits accept only numbers.')
            .min(1, "Total usage limits should be starts from 1 to 1000")
            .max(1000, "Total usage limits should not exceed 1000."),
        Usagelimitpercustomer: yup.number().label('Usagelimitpercustomer').when('TotalUsagelimits', (limitVal: number[]) => {
            if (limitVal[0]) {
                return yup.number().integer('Usage limits per customer accepts only whole numbers.')
                    .typeError('Usage limits per customer only accept numbers')
                    .min(1, "Usage limits per customer should start from 1")
                    .max(1000, 'Usage limits per customer should not exceed 1000.')
                    .test('checking', 'Usage limits per customer should not exceed the total usage limit.', (val?: number) => {
                        if (val === undefined) return true;
                        return val < 1000 ? limitVal[0] >= val : true;
                    });
            } else {
                return yup.number().label('usagelimitpercustomer')
                    .integer('Usage limits per customer accepts only whole numbers.')
                    .typeError('Usage limits per customer only accept numbers')
                    .min(1, "Usage limits per customer should start from 1")
                    .max(1000, "Usage limits per customer should not exceed 1000.");
            }
        }),
        startDate: yup.date()
            .label('startDate'),
        endDate: yup.date()
            .when("startDate", (startDate) => {
                if (startDate[0]) {
                    return yup.date().test("checkDate", 'End date is invalid', val => val ? moment(val).isAfter(startDate[0]) : true)
                }
                else {
                    return yup.date()
                        .label('endDate')
                }
            }),
        customerEligibilityType: yup.number(),
        roleDiscountMapping: yup.array()
            .label('roleDiscountMapping')
            .when("customerEligibilityType", (eligibilityType) => {
                if (customerEligibilityType?.find((i: customerEligibility) => i?.id == eligibilityType[0])?.code == 'ROLE_BASED') {
                    return yup.array().required().min(1, 'Customer Eligibility is required')
                }
                else {
                    return yup.array()
                }
            }),
        customerGroupDiscountMapping: yup.array()
            .label('customerGroupDiscountMapping')
            .when("customerEligibilityType", (eligibilityType) => {
                if (customerEligibilityType?.find((i: customerEligibility) => i?.id == eligibilityType[0])?.code == 'CUSTOMER_GROUP') {
                    return yup.array().required().min(1, 'Customer Eligibility is required')
                }
                else {
                    return yup.array()
                }
            }),
        customerDiscountMapping: yup.array()
            .label('customerDiscountMapping')
            .when("customerEligibilityType", (eligibilityType) => {
                if (customerEligibilityType?.find((i: customerEligibility) => i?.id == eligibilityType[0])?.code == 'CUSTOMERS') {
                    return yup.array().required().min(1, 'Customer Eligibility is required')
                }
                else {
                    return yup.array()
                }
            }),
        selectCustomerBuys: yup.number(),
        productBuys: yup.array()
            .label('productBuys')
            .when("selectCustomerBuys", (choosenCustomerBuys) => {
                if (customerBuys?.find((i: restrictionValueType) => i?.id == choosenCustomerBuys[0])?.code == 'PRODUCT') {
                    return yup.array().of(
                        yup.object().shape({
                            rowId: yup.number(),
                            quantity: yup.number()
                                .required("Quantity is required")
                                .typeError("Quantity is invalid!")
                                .max(999, "Quantity should not exceed 999")
                                .min(1, "Quantity should be starts from 1"),
                            buyxItem: yup.object().shape({
                                id: yup.number().required("Product is required"),
                                name: yup.string().required("Product is required")
                            })
                        }),
                    ).min(1).required('One product is required')
                }
                else {
                    return yup.array()
                }
            }),
        categoryBuys: yup.array()
            .when("selectCustomerBuys", (choosenCustomerBuys) => {
                if (customerBuys?.find((i: restrictionValueType) => i?.id == choosenCustomerBuys[0])?.code == 'CATEGORY') {
                    return yup.array().of(
                        yup.object().shape({
                            rowId: yup.number().nullable(),
                            quantity: yup.number().
                                required("Quantity is required")
                                .typeError("Quantity is invalid!")
                                .max(999, "Quantity should not exceed 999")
                                .min(1, "Quantity should be starts from 1"),
                            buyxItem: yup.object().shape({
                                id: yup.number().required("Category is required"),
                                name: yup.string().required("Category is required")
                            })
                        }),
                    ).min(1).required('One Category is required')
                }
                else {
                    return yup.array().nullable()
                }
            }),
        selectCustomerGets: yup.number(),
        productGets: yup.array()
            .when("selectCustomerGets", (chosenCustomerGets) => {
                if (customerGets?.find((i: restrictionValueType) => i?.id == chosenCustomerGets[0])?.code == "PRODUCT") {
                    return yup.array().of(
                        yup.object().shape({
                            rowId: yup.number().nullable(),
                            getyPercentage: yup.number()
                                .required("Percentage is required")
                                .max(100, "Percentage should not exceed 100.")
                                .typeError("Percentage is invalid")
                                .min(1, "Percentage should be starts from 1")
                                .integer("Percentage accepts only  whole numbers."),
                            getyItem: yup.object().shape({
                                id: yup.number().required("Product is required"),
                                name: yup.string().required("Product is required")
                            })
                        }),
                    ).min(1).required('Product is required')
                }
                else {
                    return yup.array().nullable()
                }
            }),
        categoryGets: yup.array()
            .when("selectCustomerGets", (chosenCustomerGets) => {
                if (customerGets?.find((i: restrictionValueType) => i?.id == chosenCustomerGets[0])?.code == 'CATEGORY') {
                    return yup.array().of(
                        yup.object().shape({
                            rowId: yup.number().nullable(),
                            getyPercentage: yup.number()
                                .required("Percentage is required")
                                .max(100, "Percentage should not exceed 100.")
                                .typeError("Percentage is invalid")
                                .min(1, "Percentage should be starts from 1")
                                .integer("Percentage accepts only  whole numbers."),
                            getyItem: yup.object().shape({
                                id: yup.number().required("Category is required"),
                                name: yup.string().required("Category is required")
                            })
                        }),
                    ).min(1).required('Category is required')
                }
                else {
                    return yup.array().nullable()
                }
            })
    })

    // Mwthod which is used to update/save buy X get Y discount
    const updateBuyXgetYDiscount = async (values: updatepayloadType) => {
        if (!formik.dirty) {
            ZenToast({ type: "warning", message: "There is no changes to save" })
            return
        }
        setLoad(true);
        setButtonLoader(true)

        let data: updatePayload = {
            "isChangeEligibility": true,
            "storeId": config?.storeId,
            "importId": null,
            "isBuyXGetY": true,
            "title": values?.discountTitle != '' ? String(values?.discountTitle)?.trim() : null,
            "description": values?.description != '' ? String(values?.description)?.trim() : null,
            "isActive": values?.isActive,
            // "isHidden": values?.isHidden,
            "customerEligibilityType": Number(values?.customerEligibilityType),
            "overallUsageLimit": values?.TotalUsagelimits ? Number(values?.TotalUsagelimits) : null,
            "userBasedMaxUse": values?.Usagelimitpercustomer != '' ? Number(values?.Usagelimitpercustomer?.trim()) : null,
            "startDate": values?.startDate ? moment(values?.startDate) : moment(),
            "endDate": values?.endDate ? moment(values?.endDate) : null,
            "isDeleted": false,
            "customerGroupDiscountMapping": values?.customerGroupDiscountMapping?.length > 0 ? values?.customerGroupDiscountMapping : null,
            "customerDiscountMapping": values?.customerDiscountMapping?.length > 0 ? values?.customerDiscountMapping : null,
            "roleDiscountMapping": values?.roleDiscountMapping?.length > 0 ? values?.roleDiscountMapping : null,
            "buyxItemIsProduct": customerBuys.find((val: restrictionValueType) => val.id == values?.selectCustomerBuys)?.code == 'PRODUCT' ? true : false,
            "getyItemIsProduct": customerGets.find((val: restrictionValueType) => val.id == values?.selectCustomerGets)?.code == 'PRODUCT' ? true : false,
            "buyxData": customerBuys.find((val: restrictionValueType) => val.id == values?.selectCustomerBuys)?.code == 'PRODUCT' ? values?.productBuys : values?.categoryBuys,
            "getyData": customerGets.find((val: restrictionValueType) => val.id == values?.selectCustomerGets)?.code == 'PRODUCT' ? values?.productGets : values?.categoryGets,
            "isPos": true,
            "medium": "POS",
            "isWeb": false,
            "userId": 33
        }

        if (params?.id) {
            await dispatch(updateBuyXgetY({ storeId: config?.storeId, data, discountId: params?.id })).unwrap()
                .then((updateRes) => {
                    if (updateRes) {
                        setButtonLoader(false)
                        Toast?.show({ type: "success", text1: "Success", text2: 'Buy x Get y discount updated successfully' })
                        navigation.goBack()
                    }
                }).catch((err: AxiosError) => {
                    Toast?.show({ type: "error", text1: "Error", text2: 'Failed to update the buy x get y discount.' })
                    setButtonLoader(false)
                    console.log('error in update BuyXgetYDiscount', err)
                })
        }
        else {
            await dispatch(saveBuyXgetY({ storeId: config?.storeId, data })).unwrap()
                .then((response) => {
                    if (response && response?.discount) {
                        setButtonLoader(false)
                        Toast?.show({ type: "success", text1: "Success", text2: 'Buy x Get y discount saved successfully' })
                        navigation.goBack()
                    }
                }).catch((err: AxiosError) => {
                    setButtonLoader(false)
                    Toast?.show({ type: "error", text1: "Error", text2: 'Failed to create a buy x get y discount.' })
                    console.log('error in create buyXgetY discount', err)
                })
        }
    }

    // Variable which is used to access formik value
    const formik: any = useFormik({
        initialValues: {
            // isHidden: discountValue?.isHidden != null ? discountValue?.isHidden : null,
            discountTitle: params?.id ? String(discountValue?.title) : '',
            description: params?.id ? discountValue?.description ? String(discountValue?.description) : '' : '',
            TotalUsagelimits: params?.id ? discountValue?.overallUsageLimit && parseFloat(discountValue?.overallUsageLimit) > 0 ? String(parseFloat(discountValue?.overallUsageLimit)) : '' : '',
            Usagelimitpercustomer: params?.id ? discountValue?.userBasedMaxUse && parseFloat(discountValue?.userBasedMaxUse) > 0 ? String(parseFloat(discountValue?.userBasedMaxUse)) : '' : '',
            startDate: params?.id ? (discountValue?.startDate != undefined ? discountValue?.startDate : '') : useMemo(() => new Date(), []),
            endDate: discountValue?.endDate ? discountValue?.endDate?.toString() : '',
            isActive: params?.id ? discountValue?.isActive! : true,
            selectCustomerBuys: discountValue?.choosenCustomerBuys ? discountValue?.choosenCustomerBuys : customerBuys?.find((i: restrictionValueType) => i?.code == 'PRODUCT')?.id,
            productBuys: discountValue?.buyxData ? discountValue?.buyxData : [{ quantity: '', rowId: 0, buyxItem: { id: '', name: '' }, open: false, validate: false }],
            categoryBuys: discountValue?.buyxData ? discountValue?.buyxData : [{ quantity: '', rowId: 0, buyxItem: { id: '', name: '' }, open: false }],
            selectCustomerGets: discountValue?.chosenCustomerGets ? discountValue?.chosenCustomerGets : customerGets.find((i: restrictionValueType) => i?.code == 'PRODUCT')?.id,
            productGets: discountValue?.getyData ? discountValue?.getyData : [{ getyPercentage: '', rowId: 0, getyItem: { id: '', name: '' }, open: false }],
            categoryGets: discountValue?.getyData ? discountValue?.getyData : [{ getyPercentage: '', rowId: 0, getyItem: { id: '', name: '' }, open: false }],
            customerEligibilityType: params?.id ? discountValue?.customerEligibilityType ? discountValue?.customerEligibilityType : '' : customerEligibilityType?.find((val: customerEligibility) => val.code == 'FOR_ALL')?.id,
            roleDiscountMapping: params?.id ? discountValue?.discountMappings?.roleDiscountMappings ? discountValue?.discountMappings?.roleDiscountMappings : [] : [],
            customerGroupDiscountMapping: params?.id ? discountValue?.discountMappings?.customerGroupDiscountMappings ? discountValue?.discountMappings?.customerGroupDiscountMappings : [] : [],
            customerDiscountMapping: params?.id ? discountValue?.discountMappings?.customerDiscountMappings ? discountValue?.discountMappings?.customerDiscountMappings : [] : [],
        },
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: (values: updatepayloadType) => updateBuyXgetYDiscount(values)
    });

    //UseEffect function which is used to perform backhandler operation
    useEffect(() => {
        BackHandler.addEventListener('hardwareBackPress', function () {
            if (formik?.dirty) {
                setLeavePopover(true)
            }
            else {
                navigation.goBack()
            }
            return true
        })
    }, [formik?.dirty])

    //method to perform the onConfirm functionality
    const onDateConfirm = (date: any) => {
        if (startDateSelected) {
            formik.setFieldValue('startDate', moment(date))
        }
        else {
            setEndDateExpired(false)
            formik?.setFieldValue('endDate', moment(date))
        }
        setShowDate(false)
    }

    // Method which is used for popover confirmation
    const Confirmation = (val: { name: string }) => {
        if (val?.name == 'Yes') {
            if (customerBuys.find((val: restrictionValueType) => val.id == formik?.values?.selectCustomerBuys)?.code == 'PRODUCT') {
                removeProductBuys()
            }
        }
        if (val?.name == "Okay" && expiredPopover) {
            setExpiredPopover(false)
        }
        if (val?.name == "Okay" && (isGetyProductUnavailable || isBuyyProductUnavailable)) {
            setIsGetyProductUnavailable(false)
            setIsBuyyProductUnavailable(false)
        }
        if (val?.name == "Leave Page" && leavePopover) {
            setLeavePopover(false)
            navigation.goBack()
        }
        else {
            setDeleteProductBuys(false)
            setLeavePopover(false)
        }
    }

    // Method which is used to remove product buys
    const removeProductBuys = () => {
        let tempArray = []
        let arrayValue = [...formik?.values?.productBuys]
        tempArray = arrayValue.filter(item => item.rowId != selectProductBuysId)
        tempArray.forEach((val) => {
            val.validate = false
        })
        formik.setFieldValue('productBuys', [...tempArray])
        setDeleteProductBuys(false)
    }

    // Method which is used to get one pos discount
    const getOnePosDiscount = async () => {
        let propertyRes = propertyCode?.value;
        if (!propertyRes) {
            try {
                propertyRes = await dispatch(getPosPropertyCode({ storeId: config?.storeId, propertyValue: property })).unwrap();
            } catch (error) {
                console.log("Error in get property code", error);
                return;
            }
        }

        if (propertyRes && propertyRes?.propertyValueData) {
            setCustomerEligibilityType(propertyRes?.propertyValueData?.find((item: propertyValueDataType) => item?.code == "APPLICABLE_CUSTOMERS")?.propertyValues?.map((ele: restrictionValueType) => ({ ...ele, value: ele?.id, label: ele?.value === "Customer Type" ? "Roles" : ele?.value })) || [])
            // Raw product / category lists, used both for the dropdown options and the availability check below
            let productList: productItem[] | null | undefined = productData?.value
            let categoryList: categoryData[] | null | undefined = categoryData?.value?.category
            const [productResult, categoryResult] = await Promise.all([
                productList ? Promise.resolve(null) : dispatch(getDiscountAppliesTo({ storeId: config?.storeId, url: '/products/name', data: { isDiscount: true } })).unwrap().catch((Err) => {
                    console.log("Error in get product values", Err)
                    return null
                }),
                categoryList ? Promise.resolve(null) : dispatch(getDiscountAppliesTo({ storeId: config?.storeId, url: '/categories/name', data: { isDiscount: true } })).unwrap().catch((err) => {
                    console.log("Error in get category", err)
                    return null
                }),
            ])
            if (!productList) productList = (productResult as any)?.products?.rows
            if (!categoryList) categoryList = (categoryResult as any)?.category

            if (productList) {
                setProduct(productList.map((item: productItem) => ({ value: item?.id, label: item?.name })))
            }
            if (categoryList) {
                setCategory(categoryList.map((item: categoryData) => ({ value: item?.id, label: item?.name })))
            }

            let filteredApplicableTo = propertyRes?.propertyValueData?.find((item: applicableToType) => item?.code === 'APPLICABLE_TO')?.propertyValues?.filter((item: propertyValuesType) => item?.code === 'PRODUCT' || item?.code === 'CATEGORY') || [];
            setCustomerBuys(filteredApplicableTo)
            setCustomerGets(filteredApplicableTo)
            if (params?.id == undefined) {
                const applicableCustomersItem = propertyRes?.propertyValueData.find((item: propertyValueDataType) => item.code === 'APPLICABLE_CUSTOMERS');
                formik.setFieldValue("customerEligibilityType", applicableCustomersItem?.propertyValues.find((val: restrictionValueType) => val.code === 'FOR_ALL')?.id || null);
                formik.setFieldValue("selectCustomerBuys", propertyRes?.propertyValueData?.find((item: applicableToType) => item?.code === 'APPLICABLE_TO')?.propertyValues?.find((val: propertyValuesType) => val.code == 'PRODUCT')?.id)
                formik.setFieldValue("selectCustomerGets", propertyRes?.propertyValueData?.find((item: applicableToType) => item?.code === 'APPLICABLE_TO')?.propertyValues?.find((val: propertyValuesType) => val.code == 'PRODUCT')?.id)
                setLoad(false)
            }
            else if (params?.id) {
                let res = getOneDiscountState?.value;
                if (!res || res?.discount?.id != params?.id) {
                    try {
                        res = await dispatch(getOneDiscount({ storeId: config?.storeId, discountId: params?.id })).unwrap();
                    } catch (err) {
                        console.log("Error in get one discount", err);
                    }
                }

                if (res && res?.discount) {
                    if (moment(res?.discount?.endDate).endOf('day').toDate() < moment(new Date()).endOf('day').toDate()) {
                        setEndDateExpired(true)
                        setExpiredPopover(true)
                    }
                    // Show the unavailable popover only when the list is loaded and a mapped item is missing from it
                    const getySource: { id: number | string }[] | null | undefined = res?.discount?.getyItemIsProduct ? productList : categoryList
                    const buyxSource: { id: number | string }[] | null | undefined = res?.discount?.buyxItemIsProduct ? productList : categoryList
                    const getyId = res?.discount?.getyData?.[0]?.getyItem?.id
                    if (getySource && getyId != undefined && !getySource.some((val) => val?.id == getyId)) {
                        setIsGetyProductUnavailable(true)
                    }
                    if (buyxSource && !res?.discount?.buyxData?.every((item: buyxData) => buyxSource.some((val) => val?.id == item?.buyxItem?.id))) {
                        setIsBuyyProductUnavailable(true)
                    }

                    const updatedBuyxData = res?.discount?.buyxData?.map((i: buyxData) => ({
                        ...i,
                        validate: false,
                        open: false,
                    })) || []

                    const applicableToProperty =
                        propertyRes?.propertyValueData
                            ?.find((item: applicableToType) => item?.code === 'APPLICABLE_TO')
                            ?.propertyValues

                    const productId = applicableToProperty?.find(
                        (item: propertyValuesType) => item?.code === 'PRODUCT'
                    )?.id

                    const categoryId = applicableToProperty?.find(
                        (item: propertyValuesType) => item?.code === 'CATEGORY'
                    )?.id


                    const updatedDiscount = {
                        ...res.discount,
                        buyxData: updatedBuyxData,
                        choosenCustomerBuys: res.discount.buyxItemIsProduct
                            ? productId
                            : categoryId,
                        chosenCustomerGets: res.discount.getyItemIsProduct
                            ? productId
                            : categoryId,
                    }
                    formik.setFieldValue("selectCustomerBuys", updatedDiscount.choosenCustomerBuys)
                    formik.setFieldValue("selectCustomerGets", updatedDiscount.chosenCustomerGets)
                    setDiscountValue(updatedDiscount)
                    formik.setFieldValue("customerDiscountMapping", updatedDiscount?.discountMappings?.customerDiscountMappings || [])
                    formik.setFieldValue("customerGroupDiscountMapping", updatedDiscount?.discountMappings?.customerGroupDiscountMappings || [])
                    formik.setFieldValue("roleDiscountMapping", updatedDiscount?.discountMappings?.roleDiscountMappings || [])
                    formik.setFieldValue("customerEligibilityType", updatedDiscount?.customerEligibilityType)
                    setLoad(false)
                }
            }
        }
    }

    // UseEffect hook used to make corresponding api call while selectCustomerEligiblityType is rendered
    useEffect(() => {
        if (formik?.values?.customerEligibilityType) {
            if (customerEligibilityType?.find((i: customerEligibility) => i?.id == formik?.values?.customerEligibilityType)?.code == 'ROLE_BASED') {
                if (roleData?.value) {
                    const roleType = roleData?.value?.map((item: roleType) => ({ label: item?.name, value: item?.id }));
                    setRole(roleType)
                    if (formik?.values?.roleDiscountMapping?.length > 0) {
                        const chosenValue = roleType.filter((val: roleData) => formik?.values?.roleDiscountMapping?.includes(val?.value))
                        formik?.setFieldValue("roleDiscountMapping", [...chosenValue?.map((item: roleData) => item?.value)])
                        setSelectMultipleRole(chosenValue?.map((item: roleData) => item?.label))
                    }
                    formik?.setFieldTouched("customerGroupDiscountMapping", false)
                    formik?.setFieldTouched("customerDiscountMapping", false)
                    setCustomerGroupOpen(false)
                    setOpenCustomer(false)
                    setSelectMultipleCustomerGroup([])
                    setSelectMultipleCustomer([])
                } else {
                    dispatch(getDiscountAppliesTo({ storeId: config?.storeId, url: '/roles', data: { isDiscount: true, isActive: true, issueCard: true } })).unwrap().then((role: any) => {
                        console.log(role, "From dispatch");

                        if (role && role?.roles) {
                            const roleType = role?.roles?.rows?.map((item: roleType) => ({ label: item?.name, value: item?.id }));
                            setRole(roleType)
                            if (formik?.values?.roleDiscountMapping?.length > 0) {
                                const chosenValue = roleType.filter((val: roleData) => formik?.values?.roleDiscountMapping?.includes(val?.value))
                                formik?.setFieldValue("roleDiscountMapping", [...chosenValue?.map((item: roleData) => item?.value)])
                                setSelectMultipleRole(chosenValue?.map((item: roleData) => item?.label))
                            }
                            formik?.setFieldTouched("customerGroupDiscountMapping", false)
                            formik?.setFieldTouched("customerDiscountMapping", false)
                            setCustomerGroupOpen(false)
                            setOpenCustomer(false)
                            setSelectMultipleCustomerGroup([])
                            setSelectMultipleCustomer([])
                        }
                    }).catch((error) => { console.log('error in customer eligibility role value', error) })
                }
            }
            if (customerEligibilityType?.find((i: customerEligibility) => i?.id == formik?.values?.customerEligibilityType)?.code == 'CUSTOMER_GROUP') {
                if (customerGroupData?.value) {
                    const customerGroupType = customerGroupData?.value?.map((item) => ({ label: item?.groupName, value: item?.id }));
                    setCustomerGroup(customerGroupType)
                    if (formik?.values?.customerGroupDiscountMapping?.length > 0) {
                        const chosenValue = customerGroupType.filter((val: roleData) => formik?.values?.customerGroupDiscountMapping.includes(val.value))
                        formik?.setFieldValue("customerGroupDiscountMapping", [...chosenValue?.map((item: roleData) => item?.value)])
                        setSelectMultipleCustomerGroup(chosenValue?.map((item: roleData) => item?.label))
                    }
                    formik?.setFieldTouched("roleDiscountMapping", false)
                    formik?.setFieldTouched("customerDiscountMapping", false)
                    setRoleOpen(false)
                    setOpenCustomer(false)
                    setSelectMultipleRole([])
                    setSelectMultipleCustomer([])
                } else {
                    dispatch(getDiscountAppliesTo({ storeId: config?.storeId, url: '/customers/group', data: { isDiscount: true, isActive: true, issueCard: null } })).unwrap().then((customerGroup: any) => {
                        if (customerGroup && customerGroup?.customergroup) {
                            const customerGroupType = customerGroup?.customergroup?.rows?.map((item: CustomerGroupDataProps) => ({ label: item?.groupName, value: item?.id }));
                            setCustomerGroup(customerGroupType)
                            if (formik?.values?.customerGroupDiscountMapping?.length > 0) {
                                const chosenValue = customerGroupType.filter((val: roleData) => formik?.values?.customerGroupDiscountMapping.includes(val.value))
                                formik?.setFieldValue("customerGroupDiscountMapping", [...chosenValue?.map((item: roleData) => item?.value)])
                                setSelectMultipleCustomerGroup(chosenValue?.map((item: roleData) => item?.label))
                            }
                            formik?.setFieldTouched("roleDiscountMapping", false)
                            formik?.setFieldTouched("customerDiscountMapping", false)
                            setRoleOpen(false)
                            setOpenCustomer(false)
                            setSelectMultipleRole([])
                            setSelectMultipleCustomer([])
                        }
                    }).catch((error) => { console.log('error in customer eligibility customer group value', error) })
                }
            }
            if (customerEligibilityType?.find((i: customerEligibility) => i?.id == formik?.values?.customerEligibilityType)?.code == 'CUSTOMERS') {
                if (customerData?.value?.customers?.rows) {
                    const customerType = customerData?.value?.customers?.rows?.map((item) => ({ label: `${item?.user?.firstName} ${item?.user?.email ? " - " + item?.user?.email : ""}`, value: item?.customerId }));
                    setCustomer(customerType)
                    if (formik?.values?.customerDiscountMapping?.length > 0) {
                        const chosenValue = customerType.filter((val: roleData) => formik?.values?.customerDiscountMapping.includes(val?.value))
                        formik?.setFieldValue("customerDiscountMapping", [...chosenValue?.map((item: roleData) => item?.value)])
                        setSelectMultipleCustomer(chosenValue?.map((item: roleData) => item?.label))
                    }
                    formik?.setFieldTouched("customerGroupDiscountMapping", false)
                    formik?.setFieldTouched("roleDiscountMapping", false)
                    setCustomerGroupOpen(false)
                    setRoleOpen(false)
                    setSelectMultipleCustomerGroup([])
                    setSelectMultipleRole([])
                } else {
                    dispatch(getDiscountAppliesTo({ storeId: config?.storeId, url: '/customers/name', data: { isDiscount: true, isActive: true, issueCard: null } })).unwrap().then((customer: any) => {
                        if (customer && customer?.customers) {
                            const customerType = customer?.customers?.map((item: any) => ({ label: `${item?.name} ${item?.email ? " - " + item?.email : ""}`, value: item?.id }));
                            setCustomer(customerType)
                            if (formik?.values?.customerDiscountMapping?.length > 0) {
                                const chosenValue = customerType.filter((val: roleData) => formik?.values?.customerDiscountMapping.includes(val?.value))
                                formik?.setFieldValue("customerDiscountMapping", [...chosenValue?.map((item: roleData) => item?.value)])
                                setSelectMultipleCustomer(chosenValue?.map((item: roleData) => item?.label))
                            }
                            formik?.setFieldTouched("customerGroupDiscountMapping", false)
                            formik?.setFieldTouched("roleDiscountMapping", false)
                            setCustomerGroupOpen(false)
                            setRoleOpen(false)
                            setSelectMultipleCustomerGroup([])
                            setSelectMultipleRole([])
                        }
                    }).catch((error: AxiosError) => { console.log('error in customer eligibility customer', error) })
                }
            }
        }
    }, [formik?.values?.customerEligibilityType])

    // UseEffect hook used to make checkExistDiscountName api call while name is rendered
    useEffect(() => {
        if (formik?.values?.discountTitle && !params?.id) {
            const searchDebounceFunction = setTimeout(() => {
                dispatch(checkExistBuyXgetYDiscountName({ storeId: config?.storeId, data: { title: formik?.values?.discountTitle } })).unwrap().then((res) => {
                    if (res?.exist?.alreadyExist == true) {
                        setExistName(true)
                    }
                    else {
                        setExistName(false)
                    }
                }).catch((err) => {
                    setExistName(false)
                    console.log(" Check  Discount title exists or not", err);
                })
            }, 1000)
            return () => clearTimeout(searchDebounceFunction)
        }
    }, [formik?.values?.discountTitle])

    // UseEffect hook used to make getOnePosDiscount api call while page is focused
    useEffect(() => {
        if (isFocused) {
            setLoad(true)
            getOnePosDiscount()
        }
    }, [isFocused])

    return (
        <KeyboardAvoidingView style={addEditBuyXgetYDiscountStyle.container}>
            <CommonHeader headerName={params?.id ? `${isWrite ? "Edit" : "View"} Buy X Get Y Discount` : 'Add Buy X Get Y Discount'} backIcon={true} backIconOnpress={() => { formik?.dirty ? setLeavePopover(true) : navigation.goBack() }} />
            {load ?
                <View style={addEditBuyXgetYDiscountStyle.loader}>
                    <ZenLoader viewStyle={{ backgroundColor: "transparent" }} color={appColors?.primary} lottieType="Local" lottie={require('../../../assets/infinityLoader.json')} />
                </View>
                :
                <View style={addEditBuyXgetYDiscountStyle.containerView}>
                    <View style={addEditBuyXgetYDiscountStyle.buttonView}>
                        {isWrite && <ZenButton title={params?.id ? "Update" : 'Save'} loading={buttonLoader}
                            onPress={formik?.handleSubmit}
                            buttonStyle={[addEditBuyXgetYDiscountStyle.saveBtnStyle, { backgroundColor: appColors?.primary, borderWidth: 1 }]}
                            titleStyle={addEditBuyXgetYDiscountStyle.saveBtnTextStyle}
                            containerStyle={addEditBuyXgetYDiscountStyle.buttonContainer}
                        />}
                    </View>
                    <ScrollView showsVerticalScrollIndicator={false}>
                        <View style={{ borderRadius: 10, backgroundColor: appColors?.light, marginHorizontal: 15, marginTop: 2, paddingVertical: 10, paddingHorizontal: 10 }}>
                            <ZenText content='Basic Info' color={appColors.primary} size={fontSize.mediumFontSize} bold={true} />
                            <View style={[addEditBuyXgetYDiscountStyle.container, { flexDirection: width > 600 ? 'row' : 'column', marginTop: 10, gap: 15 }]}>
                                <View style={[addEditBuyXgetYDiscountStyle.inputView]}>
                                    <ZenInput
                                        label='Discount Title *'
                                        editable={params?.id ? false : true}
                                        onChangeText={(text: string) => { formik.setFieldValue('discountTitle', text) }}
                                        value={formik?.values?.discountTitle}
                                        labelStyle={addEditBuyXgetYDiscountStyle.labelStyle}
                                        inputStyle={{ paddingHorizontal: 10 }}
                                        inputContainerStyle={{ height: 45 }}
                                        type='outlined'
                                        onBlur={() => {
                                            formik.setFieldTouched('discountTitle', true);
                                            formik.setFieldValue('discountTitle', formik?.values?.discountTitle)
                                        }}
                                        disabled={params?.id ? true : false}
                                        errorMessage={formik?.touched.discountTitle && formik?.errors.discountTitle ? formik?.errors?.discountTitle : existName ? ' Discount title already exists' : undefined}
                                        errorStyle={addEditBuyXgetYDiscountStyle.errorStyle}
                                    />
                                </View>
                                <View style={[addEditBuyXgetYDiscountStyle.inputView]}>
                                    <ZenInput
                                        label='Description'
                                        // editable={ }
                                        multiline={true}
                                        type='outlined'
                                        inputContainerStyle={{ height: 45 }}
                                        errorStyle={addEditBuyXgetYDiscountStyle.errorStyle}
                                        labelStyle={addEditBuyXgetYDiscountStyle.labelStyle}
                                        inputStyle={{ paddingHorizontal: 10 }}
                                        value={formik?.values?.description}
                                        onChangeText={(text: string) => formik.setFieldValue('description', text)}
                                        onBlur={formik?.handleBlur('description')}
                                        errorMessage={formik?.touched.description && formik?.errors.description ? formik?.errors?.description : ""}
                                    />
                                </View>
                            </View>

                            {/* Usage Limit */}
                            <View style={[addEditBuyXgetYDiscountStyle.container, { flexDirection: width > 600 ? 'row' : 'column', gap: 15 }]}>
                                <View style={[addEditBuyXgetYDiscountStyle.inputView]}>
                                    <ZenInput
                                        label='Total Usage limits'
                                        onChangeText={(text: string) => formik.setFieldValue('TotalUsagelimits', text)}
                                        value={formik?.values?.TotalUsagelimits}
                                        keyboardType='numeric'
                                        inputContainerStyle={{ height: 45 }}
                                        disabled={endDateExpired || !isWrite ? true : false}
                                        labelStyle={addEditBuyXgetYDiscountStyle.labelStyle}
                                        inputStyle={{ paddingHorizontal: 10 }}
                                        type='outlined'
                                        onBlur={() => { formik.setFieldTouched('TotalUsagelimits', true); formik.setFieldValue('TotalUsagelimits', formik?.values?.TotalUsagelimits) }}
                                        errorMessage={formik.touched.TotalUsagelimits && formik.errors.TotalUsagelimits ? formik.errors.TotalUsagelimits : undefined}
                                        errorStyle={addEditBuyXgetYDiscountStyle.errorStyle}
                                        rightIcon={
                                            <ZenToolTip
                                                height={50}
                                                width={200}
                                                backgroundColor={appColors?.lightBackgroundColor}
                                                popoverStyle={{ elevation: 4 }}
                                                content={<ZenText content='Number of times the discount is to be used' color={appColors.dark} size={fontSize.errorFontSize} />}
                                                popover={<Pressable onPress={() => { }}>
                                                    <ZenIcon name="information" type="material-community" size={16} color={appColors?.primary} style={{ marginLeft: 5, marginTop: 7 }} />
                                                </Pressable>}
                                            />
                                        }
                                    />
                                </View>
                                <View style={[addEditBuyXgetYDiscountStyle.inputView]}>
                                    <ZenInput
                                        label='Usage limits per customer'
                                        onChangeText={(text: string) => formik.setFieldValue('Usagelimitpercustomer', text)}
                                        disabled={endDateExpired || !isWrite ? true : false}
                                        value={formik?.values?.Usagelimitpercustomer}
                                        keyboardType='numeric'
                                        inputContainerStyle={{ height: 45 }}
                                        inputStyle={{ paddingHorizontal: 10 }}
                                        type='outlined'
                                        labelStyle={addEditBuyXgetYDiscountStyle.labelStyle}
                                        onBlur={() => {
                                            formik.setFieldTouched('Usagelimitpercustomer', true);
                                            formik.setFieldValue('Usagelimitpercustomer', formik?.values?.Usagelimitpercustomer)
                                        }}
                                        errorMessage={formik.touched.Usagelimitpercustomer && formik.errors.Usagelimitpercustomer ? formik.errors.Usagelimitpercustomer : undefined}
                                        errorStyle={addEditBuyXgetYDiscountStyle.errorStyle}
                                    />
                                </View>
                            </View>

                            {/* Enable Discount */}
                            <View style={{ flexDirection: "row", flex: 1, gap: 25, marginTop: 15, alignItems: "center", }}>
                                <ZenCheckBox
                                    title={'Enable'}
                                    checked={formik?.values?.isActive}
                                    disabled={endDateExpired || !isWrite ? true : false}
                                    size={22}
                                    containerStyle={{ alignSelf: "center" }}
                                    titleStyle={theme?.manualDiscountStyle?.checkBoxText}
                                    checkedColor={appColors.primary}
                                    onPress={() => { formik?.setFieldValue('isActive', !formik?.values?.isActive) }}
                                />
                                {/* <ZenCheckBox
                                    title={'Hide from store'}
                                    checked={formik?.values?.isHidden}
                                    disabled={endDateExpired || !isWrite ? true : false}
                                    size={22}
                                    containerStyle={{ alignSelf: "center" }}
                                    titleStyle={theme?.manualDiscountStyle?.checkBoxText}
                                    checkedColor={appColors.primary}
                                    onPress={() => { formik?.setFieldValue('isHidden', !formik?.values?.isHidden) }}
                                /> */}
                            </View>
                        </View>

                        {/* Customer Buys */}
                        <View style={{ backgroundColor: appColors?.light, borderRadius: 10, marginHorizontal: 15, marginTop: 10, paddingHorizontal: 10, paddingBottom: 10 }}>

                            <View style={[addEditBuyXgetYDiscountStyle.CustomerBuyView, { paddingTop: 10 }]}>
                                <ZenText content='Customer Buys' color={appColors.primary} size={fontSize.mediumFontSize} bold={true} />
                                {customerBuys?.find((i: restrictionValueType) => i?.id == formik?.values?.selectCustomerBuys)?.code == 'PRODUCT' ?
                                    <ZenButton
                                        title={'Add Product'}
                                        disabled={endDateExpired || !isWrite ? true : false}
                                        onPress={() => {
                                            if (customerBuys.find((val: restrictionValueType) => (val?.id == formik?.values?.selectCustomerBuys) && (val?.code == 'PRODUCT'))) {
                                                const allFieldsFilled = formik?.values?.productBuys.every((product: buyxData) =>
                                                    product.quantity && product.buyxItem.id && product.buyxItem.name
                                                );
                                                if (!allFieldsFilled) {
                                                    ZenToast({ type: "warning", message: 'Please fill previous fields' });
                                                } else {
                                                    formik?.setFieldValue("productBuys", [...formik?.values?.productBuys, {
                                                        rowId: Math.floor(Math.random() * Date.now()),
                                                        quantity: '',
                                                        buyxItem: { id: '', name: '' },
                                                        open: false,
                                                        validate: false
                                                    }
                                                    ]);
                                                }
                                            }
                                        }}
                                        titleStyle={{ color: appColors.primary, fontFamily: appFonts.bold, fontSize: fontSize.smallerFontSize }}
                                        buttonStyle={[addEditBuyXgetYDiscountStyle.addProductBtnStyle, { backgroundColor: appColors?.light }]}
                                    /> : undefined
                                }
                            </View>

                            {/* Customer Buys Radio Buttons */}
                            <View style={[addEditBuyXgetYDiscountStyle.container, { flexDirection: 'row', gap: 15 }]}>
                                {customerBuys?.map((value: restrictionValueType, id: number) => (
                                    <View key={id} style={{ marginTop: customerBuys?.find((i: restrictionValueType) => i?.id == formik?.values?.selectCustomerBuys)?.code == 'PRODUCT' ? 0 : 15 }}>
                                        <ZenCheckBox
                                            checkedColor={appColors.primary}
                                            title={value?.value}
                                            titleStyle={{ fontSize: fontSize?.smallerFontSize }}
                                            checkedIcon="dot-circle-o"
                                            unCheckedIcon="circle-o"
                                            disabled={endDateExpired || !isWrite ? true : false}
                                            checked={value?.id == formik?.values?.selectCustomerBuys}
                                            onPress={() => {
                                                formik.setFieldValue("selectCustomerBuys", value?.id)
                                                if (value?.code == 'PRODUCT') {
                                                    formik.setFieldTouched("categoryBuys", false)
                                                    formik.setFieldValue("productBuys", [{ "buyxItem": { "id": "", "name": "" }, "open": false, "quantity": "", "rowId": 0, validate: false }])
                                                    formik.setFieldValue("categoryBuys", [{ quantity: '', rowId: 0, buyxItem: { id: '', name: '' }, open: false }])
                                                }
                                                else {
                                                    formik.setFieldTouched("categoryBuys", false)
                                                    formik.setFieldValue("categoryBuys", [{ quantity: '', rowId: 0, buyxItem: { id: '', name: '' }, open: false }])
                                                    formik.setFieldValue("productBuys", [{ quantity: '', rowId: 0, buyxItem: { id: '', name: '' }, open: false, validate: false }])
                                                }
                                            }}
                                        />
                                    </View>
                                ))}
                            </View>

                            {/* Customer Buys Product */}
                            {customerBuys?.find((i: restrictionValueType) => i?.id == formik?.values?.selectCustomerBuys)?.code == 'PRODUCT' ?
                                <View style={{ flex: 1, marginTop: 10 }}>
                                    {formik?.values?.productBuys && formik?.values?.productBuys.map((val: buyxData, index: number) => (
                                        <View key={index} style={[addEditBuyXgetYDiscountStyle.container, { flexDirection: 'row', marginTop: 7, gap: 15, }]}>
                                            <View style={{ flex: 0.5 }}>
                                                <ZenDropdown
                                                    title='Product *'
                                                    listItemLabelStyle={{ fontSize: fontSize?.smallerFontSize, fontFamily: appFonts?.medium }}
                                                    titleStyle={{ color: appColors.labelColor, fontSize: fontSize.smallerFontSize }}
                                                    items={product}
                                                    open={formik?.values?.productBuys[index]?.open}
                                                    value={formik?.values?.productBuys[index]?.buyxItem?.id}
                                                    setValue={() => { }}
                                                    setOpen={(open) => {
                                                        formik.setFieldValue(`productBuys[${index}].open`, open, false)
                                                    }}
                                                    onPress={() => {
                                                        formik?.setFieldTouched(`productBuys[${index}].buyxItem.id`, true, false)
                                                    }}
                                                    dropdownDirection='TOP'
                                                    searchable={true}
                                                    closeAfterSelecting={true}
                                                    disabled={endDateExpired || !isWrite ? true : false}
                                                    placeholder='Select Product'
                                                    searchPlaceholder="Search Specific Product"
                                                    searchPlaceholderTextColor={appColors.grey}
                                                    style={{ height: 45 }}
                                                    onSelectItem={(item: any) => {
                                                        const existingItem = formik?.values?.productBuys?.find((val: selectProductType) => val?.buyxItem?.id == item?.value);
                                                        const isDuplicate = existingItem != undefined && existingItem;
                                                        formik.setFieldTouched(`productBuys[${index}].buyxItem.id`, true, false);
                                                        formik.setFieldValue(`productBuys[${index}].validate`, isDuplicate, false);
                                                        formik.setFieldValue(`productBuys[${index}].buyxItem`, { id: item.value, name: item.label }, true);
                                                    }}
                                                />
                                                {
                                                    (((formik?.touched?.productBuys && formik?.touched?.productBuys[index]?.buyxItem?.id) || formik?.submitCount > 0) && (formik?.errors?.productBuys as any)?.[index]?.buyxItem?.id && !formik?.values?.productBuys[index]?.validate) ?
                                                        <ZenText content={"Buy's item is required."} style={{ color: appColors.red, fontSize: fontSize?.errorFontSize }} />
                                                        : null
                                                }
                                                {
                                                    (((formik?.touched?.productBuys && formik?.touched?.productBuys[index]?.buyxItem?.id) || formik?.submitCount > 0) && formik?.values?.productBuys[index]?.validate && formik?.values?.productBuys[index]?.buyxItem?.id) ?
                                                        <ZenText content={"This item already exist"} style={{ color: appColors.red, fontSize: fontSize?.errorFontSize }} />
                                                        : null
                                                }
                                            </View>
                                            <View style={{ flex: 0.5, flexDirection: 'row', alignItems: "center" }}>
                                                <View style={{ flex: 0.9 }}>
                                                    <ZenInput
                                                        inputContainerStyle={{ height: 45 }}
                                                        label='Quantity *'
                                                        keyboardType='numeric'
                                                        onChangeText={(text: string) => formik.setFieldValue(`productBuys[${index}].quantity`, text)}
                                                        value={formik?.values?.productBuys[index]?.quantity != '' ? String(formik?.values?.productBuys[index]?.quantity) : ''}
                                                        labelStyle={addEditBuyXgetYDiscountStyle.labelStyle}
                                                        disabled={endDateExpired || !isWrite ? true : false}
                                                        inputStyle={{ paddingHorizontal: 10 }}
                                                        type='outlined'
                                                        onBlur={formik.handleBlur(`productBuys[${index}].quantity`)}
                                                        errorMessage={formik?.touched?.productBuys && formik?.touched?.productBuys[index]?.quantity && formik?.errors?.productBuys ? formik?.errors?.productBuys[index]?.quantity : undefined}
                                                        errorStyle={addEditBuyXgetYDiscountStyle.errorStyle}
                                                    />
                                                </View>
                                                <View style={{ flex: 0.1, alignItems: 'flex-end', justifyContent: 'center' }}>
                                                    <ZenIcon name={'delete-outline'} type={"material-community"} size={width > 600 ? 30 : 22} color={'#d72c0c'}
                                                        onPress={() => {
                                                            if (formik?.values?.productBuys.length == 1) {
                                                                ZenToast({ type: "warning", message: 'At least one buy X category / product is required' })
                                                            }
                                                            else if (!val?.buyxItem?.id && !val?.quantity) {
                                                                let tempArray = formik?.values?.productBuys.filter((item: buyxData) => item.rowId != val?.rowId)
                                                                tempArray.forEach((val: buyxData) => {
                                                                    val.validate = false
                                                                })
                                                                formik.setFieldValue('productBuys', [...tempArray])
                                                            }
                                                            else {
                                                                setSelectProductBuysId(val?.rowId)
                                                                setDeleteProductBuys(true)
                                                            }
                                                        }} />
                                                </View>
                                            </View>
                                        </View>
                                    ))}
                                </View> :
                                <View>
                                    {[...formik?.values?.categoryBuys]?.length > 0 && [...formik?.values?.categoryBuys].map((val: buyxData, index) => (
                                        <View key={index} style={{ flex: 1, flexDirection: width > 600 ? "row" : 'column', gap: 15, marginTop: 10, }}>
                                            <View style={addEditBuyXgetYDiscountStyle.inputView}>
                                                <ZenDropdown
                                                    title='Category *'
                                                    listItemLabelStyle={{ fontSize: fontSize?.smallerFontSize, fontFamily: appFonts?.medium }}
                                                    titleStyle={{ color: appColors.labelColor, fontSize: fontSize.smallerFontSize }}
                                                    multiple={false}
                                                    setValue={() => { }}
                                                    items={category}
                                                    onSelectItem={(item) => {
                                                        formik.setFieldTouched(`categoryBuys[${index}].buyxItem.id`, true, false);
                                                        formik.setFieldValue(`categoryBuys[${index}].buyxItem`, { id: item?.value, name: item?.label }, true);
                                                    }}
                                                    closeAfterSelecting={true}
                                                    value={formik?.values?.categoryBuys[index]?.buyxItem?.id}
                                                    maxHeight={180}
                                                    open={formik?.values?.categoryBuys[index]?.open}
                                                    setOpen={(open) => {
                                                        formik.setFieldValue(`categoryBuys[${index}].open`, open, false);
                                                    }}
                                                    disabled={endDateExpired || !isWrite ? true : false}
                                                    onPress={() => formik?.setFieldTouched(`categoryBuys[${index}].buyxItem.id`, true, false)}
                                                    style={{ height: 45 }}
                                                    dropdownDirection='TOP'
                                                    searchable={true}
                                                    placeholder='Select Category'
                                                    searchPlaceholder="Search Specific Category"
                                                    searchPlaceholderTextColor={appColors.grey}
                                                />
                                                {(((formik?.touched?.categoryBuys && formik?.touched?.categoryBuys[index]?.buyxItem?.id) || formik?.submitCount > 0) && (formik?.errors?.categoryBuys as any)?.[index]?.buyxItem?.id) ? <ZenText content={"Category is required"} style={{ color: appColors.red, fontSize: fontSize.errorFontSize }} /> : null}
                                            </View>
                                            <View style={[addEditBuyXgetYDiscountStyle.inputView,]}>
                                                <ZenInput
                                                    label='Quantity *'
                                                    inputContainerStyle={{ height: 45 }}
                                                    keyboardType='numeric'
                                                    onChangeText={(text: string) => formik.setFieldValue(`categoryBuys[${index}].quantity`, text)}
                                                    value={formik?.values?.categoryBuys[index]?.quantity != '' ? String(formik?.values?.categoryBuys[index]?.quantity) : ''}
                                                    labelStyle={[addEditBuyXgetYDiscountStyle.labelStyle, { marginLeft: width < 600 ? 9 : undefined }]}
                                                    type='outlined'
                                                    inputStyle={{ paddingHorizontal: 10 }}
                                                    disabled={endDateExpired || !isWrite ? true : false}
                                                    onBlur={formik.handleBlur(`categoryBuys[${index}].quantity`)}
                                                    errorMessage={formik?.touched?.categoryBuys && formik?.touched?.categoryBuys[index]?.quantity && formik?.errors?.categoryBuys ? formik?.errors?.categoryBuys[index]?.quantity : undefined}
                                                    errorStyle={addEditBuyXgetYDiscountStyle.errorStyle}
                                                />
                                            </View>
                                        </View>
                                    ))}
                                </View>
                            }
                        </View>
                        <View style={{ backgroundColor: appColors?.light, borderRadius: 10, paddingTop: 15, marginHorizontal: 15, marginTop: 10, paddingBottom: 5, paddingHorizontal: 10 }}>
                            <ZenText content='Customer Gets' color={appColors.primary} size={fontSize.mediumFontSize} bold={true} />
                            <View style={[addEditBuyXgetYDiscountStyle.customerGetsView, { paddingBottom: 10, gap: 15 }]}>
                                {customerGets?.map((value: restrictionValueType, index) => {
                                    return (
                                        value.code != 'ORDER' &&
                                        <View key={index} style={{ marginTop: 8 }}>
                                            <ZenCheckBox
                                                checkedColor={appColors.primary}
                                                title={value?.value}
                                                checkedIcon="dot-circle-o"
                                                titleStyle={{ fontSize: fontSize?.smallerFontSize }}
                                                unCheckedIcon="circle-o"
                                                checked={value?.id == formik?.values?.selectCustomerGets}
                                                disabled={endDateExpired || !isWrite ? true : false}
                                                onPress={() => {
                                                    formik.setFieldValue("selectCustomerGets", value?.id)
                                                    if (value?.code == 'PRODUCT') {
                                                        formik.setFieldValue("categoryGets", [{ getyPercentage: '', rowId: 0, getyItem: { id: '', name: '' }, open: false }])
                                                    }
                                                    else {
                                                        formik.setFieldValue("productGets", [{ getyPercentage: '', rowId: 0, getyItem: { id: '', name: '' }, open: false }])
                                                    }
                                                }}
                                            />
                                        </View>
                                    );
                                })}
                            </View>
                            {customerGets?.find((i: restrictionValueType) => i?.id == formik?.values?.selectCustomerGets)?.code == 'PRODUCT' ?
                                formik?.values?.productGets && formik?.values?.productGets?.map((val: getyData, index: number) => (
                                    <View key={index} style={{ flex: 1, flexDirection: width > 600 ? "row" : 'column', gap: 15, marginTop: 10 }}>
                                        <View style={[addEditBuyXgetYDiscountStyle.inputView]}>
                                            <ZenDropdown
                                                title='Product *'
                                                titleStyle={{ color: appColors.labelColor, fontSize: fontSize.smallerFontSize }}
                                                multiple={false}
                                                setValue={() => { }}
                                                items={product}
                                                open={formik?.values?.productGets[index]?.open}
                                                setOpen={(open) => {
                                                    formik.setFieldValue(`productGets[${index}].open`, open, false)
                                                }}
                                                value={formik?.values?.productGets[index]?.getyItem?.id}
                                                maxHeight={180}
                                                disabled={endDateExpired || !isWrite ? true : false}
                                                onPress={() => { formik.setFieldTouched(`productGets[${index}].getyItem.id`, true, false); }}
                                                style={{ height: 45 }}
                                                dropdownDirection='TOP'
                                                listItemLabelStyle={{ fontSize: fontSize?.smallerFontSize, fontFamily: appFonts?.medium }}
                                                onSelectItem={(item) => {
                                                    formik.setFieldTouched(`productGets[${index}].getyItem.id`, true, false);
                                                    formik.setFieldValue(`productGets[${index}].getyItem`, { id: item.value, name: item.label }, true);
                                                }}
                                                labelStyle={{ color: appColors.lightDark, fontSize: fontSize.smallerFontSize, fontFamily: appFonts?.medium }}
                                                searchable={true}
                                                placeholder=''
                                                searchPlaceholder="Search Specific Product"
                                                ListEmptyComponent={() => (
                                                    <View style={{ flex: 1, justifyContent: "center", alignItems: 'center', padding: 10 }}>
                                                        <ZenText content={"No records found"} />
                                                    </View>
                                                )}
                                                searchPlaceholderTextColor={appColors.grey}
                                            />
                                            {(((formik?.touched?.productGets && formik?.touched?.productGets[index]?.getyItem?.id) || formik?.submitCount > 0) && (formik?.errors?.productGets as any)?.[index]?.getyItem?.id) ? <ZenText content={"Get's Item is required"} style={{ color: appColors.red, fontSize: fontSize.errorFontSize, marginBottom: 10 }} /> : null}
                                        </View>
                                        <View style={[addEditBuyXgetYDiscountStyle.inputView]}>
                                            <ZenInput
                                                label='Percentage *'
                                                disabled={endDateExpired || !isWrite ? true : false}
                                                keyboardType='numeric'
                                                onChangeText={(text: string) => formik.setFieldValue(`productGets[${index}].getyPercentage`, text)}
                                                value={formik?.values?.productGets[index]?.getyPercentage != '' ? String(formik?.values?.productGets[index]?.getyPercentage) : ''}
                                                labelStyle={addEditBuyXgetYDiscountStyle.labelStyle}
                                                type='outlined'
                                                inputStyle={{ paddingHorizontal: 10, color: appColors.lightDark, fontSize: fontSize.smallerFontSize, fontFamily: appFonts?.medium }}
                                                inputContainerStyle={{ height: 45 }}
                                                onBlur={formik.handleBlur(`productGets[${index}].getyPercentage`)}
                                                errorMessage={formik?.touched?.productGets && formik?.touched?.productGets[index]?.getyPercentage && formik?.errors?.productGets ? formik?.errors?.productGets[index]?.getyPercentage : null}
                                                errorStyle={[addEditBuyXgetYDiscountStyle.errorStyle, { marginBottom: formik?.touched?.productGets && formik?.touched?.productGets[index]?.getyPercentage && formik?.errors?.productGets ? 10 : undefined }]}
                                            />
                                        </View>
                                    </View>)) :
                                formik?.values?.categoryGets && formik?.values?.categoryGets?.map((val: getyData, index: number) => (
                                    <View key={index} style={{ flex: 1, flexDirection: width > 600 ? "row" : 'column', gap: 15, marginTop: 10 }}>
                                        <View style={addEditBuyXgetYDiscountStyle.inputView}>
                                            <ZenDropdown
                                                title='Category *'
                                                listItemLabelStyle={{ fontSize: fontSize?.smallerFontSize, fontFamily: appFonts?.medium }}
                                                titleStyle={{ color: appColors.labelColor, fontSize: fontSize.smallerFontSize }}
                                                multiple={false}
                                                setValue={() => { }}
                                                items={category}
                                                onSelectItem={(item) => {
                                                    formik.setFieldTouched(`categoryGets[${index}].getyItem.id`, true, false);
                                                    formik.setFieldValue(`categoryGets[${index}].getyItem`, { id: item?.value, name: item.label }, true);
                                                }}
                                                closeAfterSelecting={true}
                                                value={formik?.values?.categoryGets[index]?.getyItem?.id}
                                                maxHeight={180}
                                                open={formik?.values?.categoryGets[index]?.open}
                                                setOpen={(open) => { formik.setFieldValue(`categoryGets[${index}].open`, open, false); }}
                                                disabled={endDateExpired || !isWrite ? true : false}
                                                onPress={() => formik.setFieldTouched(`categoryGets[${index}].getyItem.id`, true, false)}
                                                style={{ height: 45 }}
                                                dropdownDirection='TOP'
                                                searchable={true}
                                                placeholder='Select Category'
                                                searchPlaceholder="Search Specific Category"
                                                searchPlaceholderTextColor={appColors.grey}
                                            />
                                            {(((formik?.touched?.categoryGets && formik?.touched?.categoryGets[index]?.getyItem?.id) || formik?.submitCount > 0) && (formik?.errors?.categoryGets as any)?.[index]?.getyItem?.id) ? <ZenText content={"Get's Item is required"} style={{ color: appColors.red, fontSize: fontSize.errorFontSize, marginBottom: 10 }} /> : null}
                                        </View>
                                        <View style={[addEditBuyXgetYDiscountStyle.inputView]}>
                                            <ZenInput
                                                label='Percentage *'
                                                disabled={endDateExpired || !isWrite ? true : false}
                                                keyboardType='numeric'
                                                onChangeText={(text: string) => formik.setFieldValue(`categoryGets[${index}].getyPercentage`, text)}
                                                value={formik?.values?.categoryGets[index]?.getyPercentage != '' ? String(formik?.values?.categoryGets[index]?.getyPercentage) : ''}
                                                labelStyle={addEditBuyXgetYDiscountStyle.labelStyle}
                                                type='outlined'
                                                inputStyle={{ paddingHorizontal: 10, color: appColors.lightDark, fontSize: fontSize.smallerFontSize, fontFamily: appFonts?.medium }}
                                                inputContainerStyle={{ height: 45 }}
                                                onBlur={formik.handleBlur(`categoryGets[${index}].getyPercentage`)}
                                                errorMessage={formik?.touched?.categoryGets && formik?.touched?.categoryGets[index]?.getyPercentage && formik?.errors?.categoryGets ? formik?.errors?.categoryGets[index]?.getyPercentage : null}
                                                errorStyle={[addEditBuyXgetYDiscountStyle.errorStyle, { marginBottom: formik?.touched?.categoryGets && formik?.touched?.categoryGets[index]?.getyPercentage && formik?.errors?.categoryGets ? 10 : undefined }]}
                                            />
                                        </View>
                                    </View>
                                ))
                            }
                        </View>
                        <View style={{ backgroundColor: appColors?.light, borderRadius: 10, paddingTop: 15, marginHorizontal: 15, marginTop: 10, paddingBottom: 5, paddingHorizontal: 10 }}>
                            <ZenText content='Schedule' size={fontSize.mediumFontSize} bold={true} color={appColors.primary} />
                            <View style={{ flex: 1, flexDirection: width > 600 ? 'row' : 'column', marginTop: 10, gap: 15 }}>
                                <View style={[addEditBuyXgetYDiscountStyle.inputView]}>
                                    <Pressable
                                        disabled={endDateExpired || !isWrite ? true : false}
                                        onPress={() => {
                                            if (formik?.values?.startDate != '' && (moment(formik?.values?.startDate).endOf('day').toDate() > moment(new Date()).endOf('day').toDate())) {
                                                setDate(new Date(formik?.values?.startDate))
                                            }
                                            else {
                                                setDate(new Date())
                                                formik.setFieldTouched('startDate', true)
                                            }
                                            setStartDateSelected(true)
                                            setShowDate(!showDate)
                                        }}
                                        style={{ position: "absolute", height: 50, top: 20, marginHorizontal: 15, width: "80%", zIndex: 10 }}></Pressable>
                                    <ZenInput
                                        label='Start Date'
                                        placeholder='MM/DD/YYYY'
                                        onChangeText={() => { }}
                                        value={formik?.values?.startDate != '' ? moment(new Date(formik?.values?.startDate))?.format('MM/DD/YYYY')?.toString() : ""}
                                        labelStyle={[addEditBuyXgetYDiscountStyle.labelStyle]}
                                        type='outlined'
                                        editable={false}
                                        inputContainerStyle={{ height: 45 }}
                                        inputStyle={{ paddingHorizontal: 10 }}
                                        errorMessage={formik?.errors?.startDate && formik?.touched?.startDate ? formik?.errors?.startDate : undefined}
                                        errorStyle={addEditBuyXgetYDiscountStyle.errorStyle}
                                        disabled={endDateExpired || !isWrite ? true : false}
                                        rightIcon={<ZenIcon name="calendar" type='material-community' size={20} color={appColors.grey} disabled={endDateExpired || !isWrite}
                                        />}
                                    />
                                </View>
                                <View style={[addEditBuyXgetYDiscountStyle.inputView]}>
                                    <Pressable
                                        disabled={!isWrite}
                                        onPress={() => {
                                            if (formik?.values?.endDate != '' && (moment(formik?.values?.endDate).endOf('day').toDate() > moment(new Date()).endOf('day').toDate())) {
                                                setDate(new Date(formik?.values?.endDate))
                                            }
                                            else {
                                                setDate(new Date())
                                            }
                                            formik.setFieldTouched('endDate', true)
                                            setStartDateSelected(false)
                                            setShowDate(!showDate)
                                        }}
                                        style={{ position: "absolute", height: 50, top: 20, marginHorizontal: 15, width: "80%", zIndex: 10 }}></Pressable>
                                    <ZenInput
                                        label='End Date'
                                        placeholder='MM/DD/YYYY'
                                        onChangeText={() => { }}
                                        value={formik?.values?.endDate != '' ? moment(new Date(formik?.values?.endDate))?.format('MM/DD/YYYY')?.toString() : ""}
                                        labelStyle={addEditBuyXgetYDiscountStyle.labelStyle}
                                        type='outlined'
                                        editable={false}
                                        inputContainerStyle={{ height: 45 }}
                                        inputStyle={{ paddingHorizontal: 10 }}
                                        errorMessage={formik?.errors?.endDate && formik?.touched?.endDate ? formik?.errors?.endDate : undefined}
                                        errorStyle={[addEditBuyXgetYDiscountStyle.errorStyle]}
                                        rightIcon={<ZenIcon name="calendar" size={20} type='material-community' color={appColors.grey} disabled={!isWrite}
                                        />}
                                    />
                                </View>
                                {showDate && <ZenDateTimePicker
                                    mode='date'
                                    onConfirm={(val) => { onDateConfirm(val) }}
                                    minimumDate={startDateSelected ? new Date(moment().format("YYYY-MM-DD")) : (formik.values?.startDate ? new Date(formik.values?.startDate) : new Date(moment().format("YYYY-MM-DD")))}
                                    maximumDate={startDateSelected && formik?.values?.endDate ? new Date(formik?.values?.endDate) : undefined}
                                    open={showDate}
                                    onCancel={() => { setShowDate(false) }}
                                    date={mydate}
                                />}
                            </View>
                        </View>
                        <View style={{ backgroundColor: appColors?.light, borderRadius: 10, paddingTop: 15, marginHorizontal: 15, marginTop: 10, paddingBottom: 20, marginBottom: 15, paddingHorizontal: 10 }}>
                            <ZenText content='Customer Eligibility' size={fontSize.mediumFontSize} bold={true} color={appColors.primary} />
                            <View style={[addEditBuyXgetYDiscountStyle.container, { flexDirection: width > 600 ? 'row' : 'column', gap: 15 }]}>
                                <View style={{ marginTop: 10, flex: (formik?.values?.customerEligibilityType == 1 || formik?.values?.customerEligibilityType == '') ? 1 : 0.5 }}>
                                    <ZenDropdown
                                        title='Customer Eligibility Type *'
                                        listItemLabelStyle={{ fontSize: fontSize?.smallerFontSize, fontFamily: appFonts?.medium }}
                                        titleStyle={{ color: appColors.labelColor, fontSize: fontSize.smallerFontSize }}
                                        multiple={false}
                                        setValue={(value: any) => { }}
                                        items={customerEligibilityType}
                                        open={eligibilityOpen}
                                        setOpen={setEligibilityOpen}
                                        onSelectItem={(item: any) => {
                                            const isForAll = customerEligibilityType?.find((i: customerEligibility) => i?.id == item?.value)?.code == 'FOR_ALL';
                                            formik?.setFieldTouched('customerEligibilityType', true, false);
                                            if (isForAll) {
                                                formik?.setFieldTouched("customerGroupDiscountMapping", false, false);
                                                formik?.setFieldTouched("roleDiscountMapping", false, false);
                                                formik?.setFieldTouched("customerDiscountMapping", false, false);
                                                formik.setValues({
                                                    ...formik.values,
                                                    customerGroupDiscountMapping: [],
                                                    roleDiscountMapping: [],
                                                    customerDiscountMapping: [],
                                                    customerEligibilityType: item?.value
                                                }, true);
                                            } else {
                                                formik.setFieldValue('customerEligibilityType', item?.value, true);
                                            }
                                        }}
                                        value={formik?.values?.customerEligibilityType}
                                        style={{ height: 45, marginTop: 5 }}
                                        dropdownDirection='TOP'
                                        labelStyle={{ color: appColors.lightDark, fontSize: fontSize.smallerFontSize }}
                                    />
                                </View>
                                {customerEligibilityType?.find((i: customerEligibility) => i?.value == formik?.values?.customerEligibilityType)?.code == 'CUSTOMER_GROUP' &&
                                    <View style={[addEditBuyXgetYDiscountStyle.inputView, { marginTop: width < 600 ? 10 : 10 }]}>
                                        <ZenDropdown
                                            title='Choose Customer Group *'
                                            titleStyle={{ color: appColors.labelColor, fontSize: fontSize.smallerFontSize }}
                                            multiple={true}
                                            setValue={(value: any) => { }}
                                            items={CustomerGroup}
                                            open={customerGroupOpen}
                                            setOpen={setCustomerGroupOpen}
                                            listItemLabelStyle={{ fontSize: fontSize?.smallerFontSize, fontFamily: appFonts?.medium }}
                                            onSelectItem={(item) => {
                                                setSelectMultipleCustomerGroup(item.map((e) => e.label));
                                                formik?.setFieldTouched('customerGroupDiscountMapping', true, false);
                                                formik.setValues({
                                                    ...formik.values,
                                                    customerGroupDiscountMapping: item.map((e) => e.value),
                                                    roleDiscountMapping: [],
                                                    customerDiscountMapping: []
                                                }, true);
                                            }}
                                            onPress={() => { formik?.setFieldTouched('customerGroupDiscountMapping', true, false) }}
                                            multipleText={selectMultipleCustomerGroup && selectMultipleCustomerGroup?.length > 2 ? selectMultipleCustomerGroup?.slice(0, 2).concat('....').toString() : selectMultipleCustomerGroup?.toString()}
                                            value={formik?.values?.customerGroupDiscountMapping}
                                            maxHeight={150}
                                            style={{ height: 45, marginTop: 5 }}
                                            dropdownDirection='TOP'
                                            labelStyle={{ color: appColors.lightDark, fontSize: fontSize.smallerFontSize }}
                                            searchable={true}
                                            placeholder='Select Customer Group'
                                            searchPlaceholder='Search Customer Group'
                                            ListEmptyComponent={() => (
                                                <View style={{ flex: 1, justifyContent: "center", alignItems: 'center', padding: 10 }}>
                                                    <ZenText content={"No records found"} />
                                                </View>
                                            )}
                                            searchPlaceholderTextColor={appColors.grey}
                                        />
                                        {((formik?.touched?.customerGroupDiscountMapping || formik?.submitCount > 0) && formik?.errors?.customerGroupDiscountMapping) ? <ZenText content={formik?.errors?.customerGroupDiscountMapping as string} style={{ color: appColors.red, fontSize: fontSize.errorFontSize }} /> : null}
                                    </View>
                                }
                                {customerEligibilityType?.find((i: customerEligibility) => i?.value == formik?.values?.customerEligibilityType)?.code == 'ROLE_BASED' &&
                                    <View style={[addEditBuyXgetYDiscountStyle.inputView, { marginTop: width < 600 ? 10 : 10 }]}>
                                        <ZenDropdown
                                            title='Choose Role *'
                                            listItemLabelStyle={{ fontSize: fontSize?.smallerFontSize, fontFamily: appFonts?.medium }}
                                            titleStyle={{ color: appColors.labelColor, fontSize: fontSize.smallerFontSize }}
                                            items={role}
                                            multiple={true}
                                            setValue={(value: any) => { }}
                                            open={roleOpen}
                                            setOpen={setRoleOpen}
                                            onSelectItem={(item) => {
                                                setSelectMultipleRole(item.map((e) => e.label));
                                                formik?.setFieldTouched('roleDiscountMapping', true, false);
                                                formik.setValues({
                                                    ...formik.values,
                                                    roleDiscountMapping: item.map((e) => e.value),
                                                    customerGroupDiscountMapping: [],
                                                    customerDiscountMapping: []
                                                }, true);
                                            }}
                                            multipleText={selectMultipleRole && selectMultipleRole?.length > 2 ? selectMultipleRole?.slice(0, 2).concat('....').toString() : selectMultipleRole?.toString()}
                                            value={formik?.values?.roleDiscountMapping}
                                            onPress={() => { formik?.setFieldTouched('roleDiscountMapping', true, false) }}
                                            maxHeight={150}
                                            style={{ height: 45, marginTop: 5 }}
                                            dropdownDirection='TOP'
                                            labelStyle={{ color: appColors.lightDark, fontSize: fontSize.smallerFontSize }}
                                            searchable={true}
                                            placeholder='Select Role'
                                            searchPlaceholder='Search Role'
                                            ListEmptyComponent={() => (
                                                <View style={{ flex: 1, justifyContent: "center", alignItems: 'center', padding: 10 }}>
                                                    <ZenText content={"No records found"} />
                                                </View>
                                            )}
                                            searchPlaceholderTextColor={appColors.grey}
                                        />
                                        {((formik?.touched?.roleDiscountMapping || formik?.submitCount > 0) && formik?.errors?.roleDiscountMapping) ? <ZenText content={formik?.errors?.roleDiscountMapping as string} style={{ color: appColors.red, fontSize: fontSize.errorFontSize }} /> : null}
                                    </View>
                                }
                                {customerEligibilityType?.find((i: customerEligibility) => i?.value == formik?.values?.customerEligibilityType)?.code == 'CUSTOMERS' &&
                                    <View style={[addEditBuyXgetYDiscountStyle.inputView, { marginTop: width < 600 ? 10 : 10 }]}>
                                        <ZenDropdown
                                            title='Choose Customers *'
                                            listItemLabelStyle={{ fontSize: fontSize?.smallerFontSize, fontFamily: appFonts?.medium }}
                                            titleStyle={{ color: appColors.labelColor, fontSize: fontSize.smallerFontSize }}
                                            items={customer}
                                            multiple={true}
                                            setValue={(value: any) => { }}
                                            open={openCustomer}
                                            setOpen={setOpenCustomer}
                                            onPress={() => formik?.setFieldTouched("customerDiscountMapping", true, false)}
                                            multipleText={selectMultipleCustomer && selectMultipleCustomer?.length > 2 ? selectMultipleCustomer?.slice(0, 2).concat('....').toString() : selectMultipleCustomer?.toString()}
                                            value={formik?.values?.customerDiscountMapping}
                                            onSelectItem={(item) => {
                                                setSelectMultipleCustomer(item.map((e) => e.label));
                                                formik?.setFieldTouched('customerDiscountMapping', true, false);
                                                formik.setValues({
                                                    ...formik.values,
                                                    customerDiscountMapping: item.map((e) => e.value),
                                                    customerGroupDiscountMapping: [],
                                                    roleDiscountMapping: []
                                                }, true);
                                            }}
                                            maxHeight={150}
                                            style={{ height: 45, marginTop: 5 }}
                                            dropdownDirection='TOP'
                                            labelStyle={{ color: appColors.lightDark, fontSize: fontSize.smallerFontSize }}
                                            searchable={true}
                                            placeholder='Select Customers'
                                            searchPlaceholder='Search Customers'
                                            ListEmptyComponent={() => (
                                                <View style={{ flex: 1, justifyContent: "center", alignItems: 'center', padding: 10 }}>
                                                    <ZenText content={"No records found"} />
                                                </View>
                                            )}
                                            searchPlaceholderTextColor={appColors.grey}
                                        />
                                        {((formik?.touched?.customerDiscountMapping || formik?.submitCount > 0) && formik?.errors?.customerDiscountMapping) ? <ZenText content={formik?.errors?.customerDiscountMapping as string} style={{ color: appColors.red, fontSize: fontSize.errorFontSize }} /> : null}
                                    </View>
                                }
                            </View>
                        </View>
                    </ScrollView>

                    <Popover isVisible={isBuyyProductUnavailable || isGetyProductUnavailable} popoverStyle={{ width: width > 900 ? 600 : width > 600 ? 450 : 350, borderRadius: 10, }}>
                        <CommonDialogBox type="OTHER" dialog={WarningProps} confirmation={Confirmation} />
                    </Popover>
                    <Popover isVisible={deleteProductBuys} popoverStyle={{ width: width > 900 ? width / 2 : width > 600 ? 450 : 350, borderRadius: 10 }}>
                        <CommonDialogBox type='DELETE' replaceValue='record' confirmation={Confirmation} />
                    </Popover>
                    <Popover isVisible={expiredPopover} popoverStyle={{ width: width > 900 ? width / 2 : width > 600 ? 450 : 350, borderRadius: 10 }}>
                        <CommonDialogBox type='OTHER' dialog={expiredDialogProps} confirmation={Confirmation} />
                    </Popover>
                    <Popover isVisible={leavePopover} popoverStyle={{ width: width > 900 ? 600 : width > 600 ? 450 : 350, borderRadius: 10, }}>
                        <CommonDialogBox type='EDIT' replaceValue="page" confirmation={Confirmation} />
                    </Popover>
                </View >
            }
        </KeyboardAvoidingView >
    )
}
export default AddEditBuyXgetYDiscount;